import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { WHATSAPP_URL } from "../content";
import { WhatsAppIcon } from "../lib/icons";

const CONSENT_KEY = "dl_cookie_consent";

export const WhatsAppFloat = () => (
  <a
    data-testid="whatsapp-float-button"
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Agendar diagnóstico pelo WhatsApp"
    className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-tinta border-2 border-lima text-lima flex items-center justify-center hover:bg-lima hover:text-tinta transition-colors duration-200"
  >
    <WhatsAppIcon className="w-6 h-6" />
  </a>
);

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(CONSENT_KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Aviso de cookies"
          className="fixed bottom-4 left-4 right-4 md:right-auto md:max-w-md z-50 bg-tinta border-2 border-lima p-5 md:p-6"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.25, 1, 0.5, 1] }}
        >
          <p className="text-creme text-xs leading-relaxed">
            Usamos cookies para melhorar sua experiência e medir resultados, em
            conformidade com a LGPD. Leia nossa{" "}
            <a href="/privacidade" className="underline text-lima">
              Política de Privacidade
            </a>
            .
          </p>
          <div className="mt-4 flex gap-2.5">
            <button
              data-testid="cookie-accept-button"
              onClick={() => choose("accepted")}
              className="bg-lima text-tinta font-sora font-bold text-xs px-5 h-10 hover:bg-[#d4ff66] transition-colors duration-150"
            >
              Aceitar
            </button>
            <button
              data-testid="cookie-decline-button"
              onClick={() => choose("declined")}
              className="border border-inkline text-creme font-sora font-bold text-xs px-5 h-10 hover:border-lima transition-colors duration-150"
            >
              Recusar
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
